import React, { useState } from "react";
import { Privilege } from "@/api/privileges";
import { DataGrid, DataGridColumn } from "@/ui-controls/DataGrid";
import MoreActionsButton from "@/ui-controls/MoreActionsButton";
import DeleteAppPrivilegePanel from "@/components/privileges/appPrivileges/DeleteAppPrivilegePanel";

interface Props {
  PrivilegeList: Privilege[];
  onDelete: (privilege: Privilege) => any;
}

enum MenuActionType {
  DEACTIVATE_PRIVILEGE = 1,
  ADD_EXTEND_PROPERTY,
}

const AppPrivilegeDetailList = (props: Props) => {
  const [menuActionType, setMenuActionType] = useState<
    MenuActionType | undefined
  >(undefined);
  const [selectedPrivilege, setSelectedPrivilege] = useState<
    Privilege | undefined
  >(undefined);

  const columns: DataGridColumn[] = [
    {
      key: "id",
      name: "Id",
      fieldName: "Id",
      minWidth: 50,
      maxWidth: 60,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "name",
      name: "Name",
      fieldName: "Name",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "description",
      name: "Description",
      fieldName: "Description",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "Actions",
      name: "",
      minWidth: 50,
      maxWidth: 70,
      onRender: (item: Privilege) => (
        <MoreActionsButton
          menu={[
            {
              key: "deactivate",
              text: "Deactivate privilege",
              iconProps: { iconName: "Delete" },
              onClick: () => {
                setMenuActionType(MenuActionType.DEACTIVATE_PRIVILEGE);
                setSelectedPrivilege(item);
              },
            },
            {
              key: "addSection",
              text: "Add",
              iconProps: { iconName: "Add" },
              subMenuProps: {
                items: [
                  // {
                  //   key: "addUser",
                  //   text: "User",
                  //   title: "Add application user",
                  //   onClick: () => {
                  //     setMenuActionType(MenuActionType.ADD_USER);
                  //     setSelectedCustomer(item);
                  //   },
                  // },
                  // {
                  //   key: "restrictPrivileges",
                  //   text: "Restrict Privileges",
                  //   title: "Restrict customer privileges",
                  //   onClick: () => {
                  //     setMenuActionType(MenuActionType.RESTRICT_PRIVILEGES);
                  //     setSelectedCustomer(item);
                  //   },
                  // },
                ],
              },
            },
          ]}
        />
      ),
    },
  ];

  const cleanPrivilegeAction = () => {
    setSelectedPrivilege(undefined);
    setMenuActionType(undefined);
  };

  const renderPrivilegeAction = () => {
    if (!selectedPrivilege || !menuActionType) return null;

    switch (menuActionType) {
      case MenuActionType.DEACTIVATE_PRIVILEGE:
        return (
          <DeleteAppPrivilegePanel
            privilege={selectedPrivilege}
            onClose={cleanPrivilegeAction}
            onDelete={(privilege) => {
              props.onDelete(privilege);
            }}
          />
        );
      // case MenuActionType.ADD_USER:
      //   return (
      //     <AppCustomerUsers
      //       ApplicationId={props.Application.Id}
      //       CustomerId={selectedCustomer.Id}
      //       ShowOnlyNewAppCustomerUserPanel={true}
      //       onCloseNewAppCustomerUserPanel={cleanCustomerAction}
      //       onSaveAppCustomerUsers={(users) =>
      //         (selectedCustomer.UsersCount = users.length)
      //       }
      //     />
      //   );
      // case MenuActionType.RESTRICT_PRIVILEGES:
      //   return <p>TODO: RESTRICT_PRIVILEGES</p>;
      default:
        return null;
    }
  };

  return (
    <>
      <DataGrid items={props.PrivilegeList} columns={columns} />
      {renderPrivilegeAction()}
    </>
  );
};

export default AppPrivilegeDetailList;
